import { Component, Output, EventEmitter, Input, inject } from '@angular/core';
import { AreaDTO } from 'src/app/services/api/api';
import { UtilService } from 'src/app/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { StringTransformationService } from 'src/app/services/transformation-helper/string-transformation.service';

@Component({
  selector: 'sb-area-list',
  templateUrl: './sb-area-list.component.html',
  styleUrls: ['./sb-area-list.component.scss'],
  standalone: false,
})
export class SbAreaListComponent {
  private readonly stringTransformation = inject(StringTransformationService);
  @Input()
  areas: AreaDTO[];

  @Output()
  areasChange: EventEmitter<AreaDTO[]> = new EventEmitter<AreaDTO[]>();

  constructor(
    public util: UtilService,
    public translate: TranslateService
  ) {}

  getClass() {
    return 'cursor-remove' + ' ' + 'selected';
  }

  toggle(item: AreaDTO) {
    const indexOfArea = this.areas.indexOf(item);
    if (indexOfArea != -1) {
      this.areas.splice(indexOfArea, 1);
      this.areasChange.emit(this.areas);
    }
  }

  getName(item: AreaDTO) {
    let hasName: boolean = item.name ? item.name.length > 0 : false;
    if (hasName) {
      return item.name + ' ' + '(ID ' + item.id + ')';
    } else {
      return 'ID ' + item.id;
    }
  }

  getDescription(item: AreaDTO) {
    return this.stringTransformation.addressToFullString(item.address);
  }
}
